import React, {Fragment, useState} from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from "react-i18next";
import {Button, Checkbox, Col, Icon, Modal, Radio, Row} from "antd";
import InfiniteScrollTable from "../../components/infinite-scroll-table";
import {
  GUTTER_MD,
  GUTTER_SM,
  MARGIN_MD,
  MODAL_WIDTH_MD,
  SPAN_HALF,
  TABLE_COL_MIN_WIDTH_ID,
  TABLE_COL_MIN_WIDTH_NAME
} from "../../styles/constants";
import EnhancedModal from "../../components/enhanced-modal";
import _ from "lodash";
import {DataLanguageConsumer} from "../../contexts/DataLanguage";
import {isArtefactValid} from "../../utils/artefactValidators";
import {reuseAction} from "../../utils/reduxReuse";
import {
  changeCodelistDetailDerivedCodelistCheckbox,
  changeCodelistDetailDerivedCodelistCreate,
  changeCodelistDetailDerivedCodelistViewMode,
  hideCodelistDetailDerivedCodelistCreate,
  readCodelistDetailDerivedCodelistSourceItemPage,
  readCodelistDetailDerivedCodelistSourceItemTree,
  readCodelistDetailDerivedCodelistTargetItemPage,
  readCodelistDetailDerivedCodelistTargetItemTree,
  restoreCodelistDetailDerivedCodelistDb,
  selectCodelistDetailDerivedCodelistAllItems,
  selectCodelistDetailDerivedCodelistSourceItem,
  selectCodelistDetailDerivedCodelistSourceTreeItem,
  selectCodelistDetailDerivedCodelistTargetItem,
  selectCodelistDetailDerivedCodelistTargetTreeItem,
  showCodelistDetailDerivedCodelistCreate,
  storeCodelistDetailDerivedCodelistItems,
  storeCodelistDetailDerivedCodelistSelectedItems,
  submitCodelistDetailDerivedCodelistCreate,
  updateCodelistDetailDerivedCodelistSourceItemPageParams,
  updateCodelistDetailDerivedCodelistTargetItemPageParams
} from "./actions";
import Call from "../../hocs/call";
import ArtefactMinForm, {ARTEFACT_MIN_FORM_MODE_CREATE} from "../../components/artefact-min-form";
import {
  NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE,
  NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE
} from "../../scenes/configuration/nodes-config/node/GeneralForm";
import CheckableItemsTree from "../../components/checkable-items-tree";
import "./style.css";

const mapStateToProps = (state, {instanceState}) => ({
  nodes: state.config.nodes,
  nodeId: state.app.endpointId,
  appLang: state.app.language,
  codelistTriplet: instanceState.codelistTriplet,
  derivedCodelist: instanceState.derivedCodelist,
  dCSourceFetchPageParams: instanceState.dCSourceFetchPageParams,
  dCSourceItemPage: instanceState.dCSourceItemPage,
  dCSourceItemCount: instanceState.dCSourceItemCount,
  dCSourceSelectedItemCount: instanceState.dCSourceSelectedItemCount,
  dCTargetFetchPageParams: instanceState.dCTargetFetchPageParams,
  dCTargetItemPage: instanceState.dCTargetItemPage,
  dCTargetItemCount: instanceState.dCTargetItemCount,
  dCTargetSelectedItemCount: instanceState.dCTargetSelectedItemCount,
  importCheckbox: instanceState.importCheckbox,
  isCreateVisible: instanceState.isCreateVisible,
  currentTab: instanceState.currentTab,
  derivedCodelistViewMode: instanceState.derivedCodelistViewMode,
  dcSourceItemTree: instanceState.dcSourceItemTree,
  dcSourceItemTreeMaxDepth: instanceState.dcSourceItemTreeMaxDepth,
  dcTargetItemTree: instanceState.dcTargetItemTree,
  dcTargetItemTreeMaxDepth: instanceState.dcTargetItemTreeMaxDepth,
  dcSourceSelectedItems: instanceState.dcSourceSelectedItems,
  dcTargetSelectedItems: instanceState.dcTargetSelectedItems,
  dcTargetItemTreeTimeStamp: instanceState.dcTargetItemTreeTimeStamp,
  dcTargetItemTreeTimestamp: instanceState.dcTargetItemTreeTimeStamp,
  maxTreeNodes: state.config.userInterface.maxTreeNodes
});

const mapDispatchToProps = (dispatch, {instancePrefix}) => ({
  onSourceItemPageParamsUpdate: fetchPageParams =>
    dispatch(reuseAction(updateCodelistDetailDerivedCodelistSourceItemPageParams(fetchPageParams), instancePrefix)),
  fetchSourceItemPage: ({
                          codelistTriplet,
                          lang,
                          pageNum,
                          pageSize,
                          itemsOrderAnnotationType,
                          searchText,
                          filters,
                          sortCol,
                          sortByDesc
                        }) =>
    dispatch(reuseAction(readCodelistDetailDerivedCodelistSourceItemPage(codelistTriplet, lang, pageNum, pageSize, itemsOrderAnnotationType, searchText, filters, sortCol, sortByDesc), instancePrefix)),
  onTargetItemPageParamsUpdate: fetchPageParams =>
    dispatch(reuseAction(updateCodelistDetailDerivedCodelistTargetItemPageParams(fetchPageParams), instancePrefix)),
  fetchTargetItemPage: ({
                          codelistTriplet,
                          lang,
                          pageNum,
                          pageSize,
                          itemsOrderAnnotationType,
                          searchText,
                          filters,
                          sortCol,
                          sortByDesc
                        }) =>
    dispatch(reuseAction(readCodelistDetailDerivedCodelistTargetItemPage(codelistTriplet, lang, pageNum, pageSize, itemsOrderAnnotationType, searchText, filters, sortCol, sortByDesc), instancePrefix)),
  onSourceItemSelect: (itemId, codelistTriplet, isSelected, lang) =>
    dispatch(reuseAction(selectCodelistDetailDerivedCodelistSourceItem(itemId, codelistTriplet, isSelected, lang), instancePrefix)),
  onTargetItemSelect: (itemId, codelistTriplet, isSelected, lang) =>
    dispatch(reuseAction(selectCodelistDetailDerivedCodelistTargetItem(itemId, codelistTriplet, isSelected, lang), instancePrefix)),
  onAllItemsSelect: (codelistTriplet, isTarget, isSelected, filter, lang) =>
    dispatch(reuseAction(selectCodelistDetailDerivedCodelistAllItems(codelistTriplet, isTarget, isSelected, filter, lang), instancePrefix)),
  onSelectedItemsStore: (isTarget, codelistTriplet, lang, importCheckbox) =>
    dispatch(reuseAction(storeCodelistDetailDerivedCodelistSelectedItems(isTarget, codelistTriplet, lang, importCheckbox), instancePrefix)),
  onItemsStore: (items, isTarget, codelistTriplet, lang, importCheckbox) =>
    dispatch(reuseAction(storeCodelistDetailDerivedCodelistItems(items, isTarget, codelistTriplet, lang, importCheckbox), instancePrefix)),
  onCheckboxChange: checkbox => dispatch(reuseAction(changeCodelistDetailDerivedCodelistCheckbox(checkbox), instancePrefix)),
  onCreateShow: (codelistTriplet, lang) =>
    dispatch(reuseAction(showCodelistDetailDerivedCodelistCreate(codelistTriplet, lang), instancePrefix)),
  onCreateHide: () => dispatch(reuseAction(hideCodelistDetailDerivedCodelistCreate(), instancePrefix)),
  onCreateChange: fields => dispatch(reuseAction(changeCodelistDetailDerivedCodelistCreate(fields), instancePrefix)),
  onCreateSubmit: (codelistTriplet, lang, derivedCodelist) =>
    dispatch(reuseAction(submitCodelistDetailDerivedCodelistCreate(codelistTriplet, lang, derivedCodelist), instancePrefix)),
  onSelectedDbRestore: codelistTriplet => dispatch(reuseAction(restoreCodelistDetailDerivedCodelistDb(codelistTriplet), instancePrefix)),
  onDerivedCodelistViewModeChange: (mode, triplet) => dispatch(reuseAction(changeCodelistDetailDerivedCodelistViewMode(mode, triplet), instancePrefix)),
  fetchDCSourceItemTree: ({triplet, lang, itemsOrderAnnotationType}) =>
    dispatch(reuseAction(readCodelistDetailDerivedCodelistSourceItemTree(triplet, lang, itemsOrderAnnotationType), instancePrefix)),
  fetchDCTargetItemTree: ({triplet, lang, itemsOrderAnnotationType}) =>
    dispatch(reuseAction(readCodelistDetailDerivedCodelistTargetItemTree(triplet, lang, itemsOrderAnnotationType), instancePrefix)),
  onSourceTreeItemSelect: itemIds => dispatch(reuseAction(selectCodelistDetailDerivedCodelistSourceTreeItem(itemIds), instancePrefix)),
  onTargetTreeItemSelect: itemIds => dispatch(reuseAction(selectCodelistDetailDerivedCodelistTargetTreeItem(itemIds), instancePrefix))
});

const TABLE_HEIGHT = 300;

const areParamsComplete = params => {
  return !["codelistTriplet", "lang", "pageNum", "pageSize"].find(key => params[key] === undefined)
};

const DerivedCodelist = ({
                           t,
                           nodes,
                           nodeId,
                           appLang,
                           agencies,
                           codelistTriplet,
                           dCSourceFetchPageParams,
                           dCSourceItemPage,
                           dCSourceItemCount,
                           dCSourceSelectedItemCount,
                           dCTargetFetchPageParams,
                           dCTargetItemPage,
                           dCTargetItemCount,
                           dCTargetSelectedItemCount,
                           isCreateVisible,
                           currentTab,
                           derivedCodelist,
                           importCheckbox,
                           isImportParentDisabled,
                           fetchSourceItemPage,
                           onSourceItemPageParamsUpdate,
                           fetchTargetItemPage,
                           onTargetItemPageParamsUpdate,
                           onSourceItemSelect,
                           onTargetItemSelect,
                           onAllItemsSelect,
                           onSelectedItemsStore,
                           onItemsStore,
                           onCheckboxChange,
                           onCreateShow,
                           onCreateChange,
                           onCreateHide,
                           onCreateSubmit,
                           onSelectedDbRestore,
                           derivedCodelistViewMode,
                           onDerivedCodelistViewModeChange,
                           fetchDCSourceItemTree,
                           fetchDCTargetItemTree,
                           dcSourceItemTree,
                           dcTargetItemTree,
                           dcSourceItemTreeMaxDepth,
                           dcTargetItemTreeMaxDepth,
                           dcSourceSelectedItems,
                           dcTargetSelectedItems,
                           onSourceTreeItemSelect,
                           onTargetTreeItemSelect,
                           dcTargetItemTreeTimeStamp,
                           dcTargetItemTreeTimestamp,
                           maxTreeNodes
                         }) => {

  const itemsOrderAnnotationType =
    _.find(nodes, node => node.general.id === nodeId).annotations.codelistsOrder.type;

  const columns = [
    {
      title: t('data.item.id.shortLabel'),
      dataIndex: 'code',
      minWidth: TABLE_COL_MIN_WIDTH_ID
    },
    {
      title: t('data.item.name.shortLabel'),
      dataIndex: 'name',
      minWidth: TABLE_COL_MIN_WIDTH_NAME
    },
    {
      title: t('data.item.parent.shortLabel'),
      dataIndex: 'parent',
      minWidth: TABLE_COL_MIN_WIDTH_ID
    }
  ];

  const [isVisible, setIsVisible] = useState(false);

  return (
    <DataLanguageConsumer>
      {dataLanguage => {
        const lang = dataLanguage || appLang;
        return (
          <Fragment>
            <EnhancedModal
              fullscreen
              visible={isVisible}
              title={t('reduxComponents.codelistDetail.tabs.derived.title')}
              onCancel={() => setIsVisible(false)}
              footer={
                <div>
                  <Button onClick={() => setIsVisible(false)} icon="zoom-out">
                    {t('commons.buttons.close.title')}
                  </Button>
                </div>
              }
            >
              <div style={{height: "100%"}}>
                <Row type="flex" justify="space-between" align="middle" gutter={32}
                     style={{marginBottom: MARGIN_MD}}>
                  <Col>
                    <Row type="flex" gutter={16}>
                      <Col>
                        <Radio.Group
                          value={derivedCodelistViewMode}
                          onChange={({target}) => {
                            if (target.value === NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE && dCSourceItemCount && dCSourceItemCount > maxTreeNodes) {
                              Modal.error({
                                title: t('components.itemList.modals.treeViewModeUnavailable.title'),
                                content: t('components.itemList.modals.treeViewModeUnavailable.content')
                              })
                            } else if (
                              (dCSourceItemPage && dCSourceItemPage.find(({isSelected}) => isSelected)) ||
                              dcSourceSelectedItems.length > 0
                            ) {
                              Modal.confirm({
                                title: t('reduxComponents.derivedItemsScheme.viewModeRadio.confirm.title'),
                                content: t('reduxComponents.derivedItemsScheme.viewModeRadio.confirm.content'),
                                onOk() {
                                  onDerivedCodelistViewModeChange(target.value, codelistTriplet)
                                },
                                cancelText: t('commons.buttons.cancel.title')
                              })
                            } else {
                              onDerivedCodelistViewModeChange(target.value, codelistTriplet);
                            }
                          }}
                        >
                          <Radio.Button value={NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE}>
                            <div
                              title={t('reduxComponents.derivedItemsScheme.viewModeRadio.table.title')}>
                              <Icon type="table"/>
                            </div>
                          </Radio.Button>
                          <Radio.Button value={NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE}>
                            <div
                              title={t('reduxComponents.derivedItemsScheme.viewModeRadio.tree.title')}>
                              <Icon type="branches" style={{transform: "rotate(90deg)"}}/>
                            </div>
                          </Radio.Button>
                        </Radio.Group>
                      </Col>
                      <Col>
                        <Button onClick={() => setIsVisible(false)} icon="zoom-out">
                          {t('reduxComponents.derivedItemsScheme.buttons.zoom.title')}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                  {derivedCodelistViewMode === NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE && (
                    <Col>
                      <Row type="flex" justify="start" align="middle" gutter={32}>
                        <Col>
                          <Row type="flex" justify="start" align="middle" gutter={GUTTER_MD}>
                            <Col>
                              {t("reduxComponents.derivedItemsScheme.preservesHierarchy.label") + ":"}
                            </Col>
                            <Col>
                              <Checkbox
                                checked={importCheckbox.preserveHierarchy}
                                onChange={e => onCheckboxChange({preserveHierarchy: e.target.checked})}
                                disabled={isImportParentDisabled}
                              />
                            </Col>
                          </Row>
                        </Col>
                        {importCheckbox.preserveHierarchy && (
                          <Col>
                            <Row type="flex" justify="start" align="middle" gutter={GUTTER_MD}>
                              <Col>
                                {t("reduxComponents.derivedItemsScheme.autoImport.label") + ":"}
                              </Col>
                              <Col>
                                {t("reduxComponents.derivedItemsScheme.autoImport.parents.label") + ":"}
                              </Col>
                              <Col>
                                <Checkbox
                                  checked={importCheckbox.importParents}
                                  onChange={e => onCheckboxChange({importParents: e.target.checked})}
                                  disabled={isImportParentDisabled}
                                />
                              </Col>
                              <Col>
                                {t("reduxComponents.derivedItemsScheme.autoImport.children.label") + ":"}
                              </Col>
                              <Col>
                                <Checkbox
                                  checked={importCheckbox.importChildren}
                                  onChange={e => onCheckboxChange({importChildren: e.target.checked})}
                                  disabled={isImportParentDisabled}
                                />
                              </Col>
                              <Col>
                                {t("reduxComponents.derivedItemsScheme.autoImport.descendants.label") + ":"}
                              </Col>
                              <Col>
                                <Checkbox
                                  checked={importCheckbox.importDescendants}
                                  onChange={e => onCheckboxChange({importDescendants: e.target.checked})}
                                  disabled={isImportParentDisabled}
                                />
                              </Col>
                            </Row>
                          </Col>
                        )}
                      </Row>
                    </Col>
                  )}
                </Row>
                <div className="redux-codelist-detail-modal__derived-codelist__fullscreen">
                  {derivedCodelistViewMode === NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE
                    ? (
                      <Row type="flex" gutter={GUTTER_MD}
                           style={{marginBottom: MARGIN_MD, height: "100%"}}>
                        <Col span={SPAN_HALF} style={{height: "100%"}}>
                          <Call
                            cb={fetchDCSourceItemTree}
                            cbParam={{
                              triplet: codelistTriplet,
                              lang,
                              itemsOrderAnnotationType,
                              dcTargetItemTreeTimeStamp
                            }}
                            disabled={derivedCodelistViewMode !== NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE}
                          >
                            <CheckableItemsTree
                              itemTree={dcSourceItemTree}
                              childrenKey="codes"
                              rightActions={
                                <Button
                                  onClick={() => onItemsStore(dcSourceSelectedItems, false, codelistTriplet, lang, importCheckbox)}
                                  icon="double-right"
                                  type="primary"
                                  disabled={dcSourceSelectedItems.length === 0}
                                >
                                  {t('reduxComponents.derivedItemsScheme.buttons.addItems.title')}
                                </Button>
                              }
                              itemTreeMaxDepth={dcSourceItemTreeMaxDepth}
                              selectedItems={dcSourceSelectedItems}
                              onSelectedItemsChange={onSourceTreeItemSelect}
                              getIsDisabledNode={({isSelectable}) => isSelectable === false}
                            />
                          </Call>
                        </Col>
                        <Col span={SPAN_HALF} style={{height: "100%"}}>
                          <Call
                            cb={fetchDCTargetItemTree}
                            cbParam={{
                              triplet: codelistTriplet,
                              lang,
                              itemsOrderAnnotationType,
                              dcTargetItemTreeTimestamp
                            }}
                            disabled={derivedCodelistViewMode !== NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE}
                          >
                            <CheckableItemsTree
                              itemTree={dcTargetItemTree}
                              childrenKey="codes"
                              rightActions={
                                <Button
                                  onClick={() => onItemsStore(dcTargetSelectedItems, true, codelistTriplet, lang)}
                                  icon="delete"
                                  type="primary"
                                  disabled={dcTargetSelectedItems.length === 0}
                                >
                                  {t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')}
                                </Button>
                              }
                              itemTreeMaxDepth={dcTargetItemTreeMaxDepth}
                              selectedItems={dcTargetSelectedItems}
                              onSelectedItemsChange={onTargetTreeItemSelect}
                            />
                          </Call>
                        </Col>
                      </Row>
                    )
                    : (
                      <Row type="flex" gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                        <Col span={SPAN_HALF}>
                          <Call
                            cb={fetchSourceItemPage}
                            cbParam={dCSourceFetchPageParams}
                            disabled={currentTab !== "derived" || dCSourceFetchPageParams === null || !areParamsComplete(dCSourceFetchPageParams)}
                          >
                            <InfiniteScrollTable
                              data={dCSourceItemPage}
                              getRowKey={({code}) => code}
                              rowCount={dCSourceItemCount}
                              columns={columns}
                              height={document.body.clientHeight - 357}
                              searchBarSpan={10}
                              rowSelection={{
                                selectedRowKeys: dCSourceItemPage
                                  ? dCSourceItemPage.filter(({isSelected}) => isSelected).map(({code}) => code)
                                  : [],
                                onSelect: (itemCode, selected) =>
                                  onSourceItemSelect(itemCode, codelistTriplet, selected, lang),
                                onSelectAll: (selected, filter) => onAllItemsSelect(codelistTriplet, false, selected, filter, lang)
                              }}
                              getIsDisabledRow={({isSelectable}) => !isSelectable}
                              rightActions={
                                <Button
                                  onClick={() => onSelectedItemsStore(false, codelistTriplet, lang, importCheckbox)}
                                  icon="double-right"
                                  type="primary"
                                  disabled={!dCSourceSelectedItemCount || dCSourceSelectedItemCount === 0}
                                >
                                  {t('reduxComponents.derivedItemsScheme.buttons.addItems.title')}
                                </Button>
                              }
                              isPaginated
                              selectedRowCount={dCSourceSelectedItemCount}
                              onChange={({
                                           pageNum,
                                           pageSize,
                                           searchText,
                                           filters,
                                           sortCol,
                                           sortByDesc
                                         }) =>
                                onSourceItemPageParamsUpdate({
                                  codelistTriplet,
                                  lang,
                                  pageNum,
                                  pageSize,
                                  searchText,
                                  filters,
                                  sortCol,
                                  sortByDesc,
                                  itemsOrderAnnotationType
                                })
                              }
                            />
                          </Call>
                        </Col>
                        <Col span={SPAN_HALF}>
                          <Call
                            cb={fetchTargetItemPage}
                            cbParam={dCTargetFetchPageParams}
                            disabled={currentTab !== "derived" || dCSourceItemPage === null || dCTargetFetchPageParams === null || !areParamsComplete(dCTargetFetchPageParams)}
                          >
                            <InfiniteScrollTable
                              data={dCTargetItemPage}
                              getRowKey={({code}) => code}
                              rowCount={dCTargetItemCount}
                              columns={columns}
                              height={document.body.clientHeight - 357}
                              searchBarSpan={10}
                              rowSelection={{
                                selectedRowKeys: dCTargetItemPage
                                  ? dCTargetItemPage.filter(({isSelected}) => isSelected).map(({code}) => code)
                                  : [],
                                onSelect: (itemCode, selected) =>
                                  onTargetItemSelect(itemCode, codelistTriplet, selected, lang),
                                onSelectAll: (selected, filter) => onAllItemsSelect(codelistTriplet, true, selected, filter, lang)
                              }}
                              rightActions={
                                <Button
                                  onClick={() => onSelectedItemsStore(true, codelistTriplet, lang)}
                                  icon="delete"
                                  type="primary"
                                  disabled={!dCTargetSelectedItemCount || dCTargetSelectedItemCount === 0}
                                >
                                  {t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')}
                                </Button>
                              }
                              isPaginated
                              selectedRowCount={dCTargetSelectedItemCount}
                              onChange={({
                                           pageNum,
                                           pageSize,
                                           searchText,
                                           filters,
                                           sortCol,
                                           sortByDesc
                                         }) =>
                                onTargetItemPageParamsUpdate({
                                  codelistTriplet,
                                  lang,
                                  pageNum,
                                  pageSize,
                                  searchText,
                                  filters,
                                  sortCol,
                                  sortByDesc,
                                  itemsOrderAnnotationType
                                })
                              }
                            />
                          </Call>
                        </Col>
                      </Row>
                    )}
                </div>
              </div>
            </EnhancedModal>
            <div>
              <Row type="flex" justify="space-between" align="middle" gutter={32}
                   style={{marginBottom: MARGIN_MD}}>
                <Col>
                  <Row type="flex" gutter={16}>
                    <Col>
                      <Radio.Group
                        value={derivedCodelistViewMode}
                        onChange={({target}) => {
                          if (target.value === NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE && dCSourceItemCount && dCSourceItemCount > maxTreeNodes) {
                            Modal.error({
                              title: t('components.itemList.modals.treeViewModeUnavailable.title'),
                              content: t('components.itemList.modals.treeViewModeUnavailable.content')
                            })
                          } else if (
                            (dCSourceItemPage && dCSourceItemPage.find(({isSelected}) => isSelected)) ||
                            dcSourceSelectedItems.length > 0
                          ) {
                            Modal.confirm({
                              title: t('reduxComponents.derivedItemsScheme.viewModeRadio.confirm.title'),
                              content: t('reduxComponents.derivedItemsScheme.viewModeRadio.confirm.content'),
                              onOk() {
                                onDerivedCodelistViewModeChange(target.value, codelistTriplet)
                              },
                              cancelText: t('commons.buttons.cancel.title')
                            })
                          } else {
                            onDerivedCodelistViewModeChange(target.value, codelistTriplet);
                          }
                        }}
                      >
                        <Radio.Button value={NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE}>
                          <div
                            title={t('reduxComponents.derivedItemsScheme.viewModeRadio.table.title')}>
                            <Icon type="table"/>
                          </div>
                        </Radio.Button>
                        <Radio.Button value={NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE}>
                          <div
                            title={t('reduxComponents.derivedItemsScheme.viewModeRadio.tree.title')}>
                            <Icon type="branches" style={{transform: "rotate(90deg)"}}/>
                          </div>
                        </Radio.Button>
                      </Radio.Group>
                    </Col>
                    <Col>
                      <Button onClick={() => setIsVisible(true)} icon="zoom-in">
                        {t('reduxComponents.derivedItemsScheme.buttons.zoom.title')}
                      </Button>
                    </Col>
                  </Row>
                </Col>
                {derivedCodelistViewMode === NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE && (
                  <Col>
                    <Row type="flex" justify="start" align="middle" gutter={32}>
                      <Col>
                        <Row type="flex" justify="start" align="middle" gutter={GUTTER_MD}>
                          <Col>
                            {t("reduxComponents.derivedItemsScheme.preservesHierarchy.label") + ":"}
                          </Col>
                          <Col>
                            <Checkbox
                              checked={importCheckbox.preserveHierarchy}
                              onChange={e => onCheckboxChange({preserveHierarchy: e.target.checked})}
                              disabled={isImportParentDisabled}
                            />
                          </Col>
                        </Row>
                      </Col>
                      {importCheckbox.preserveHierarchy && (
                        <Col>
                          <Row type="flex" justify="start" align="middle" gutter={GUTTER_MD}>
                            <Col>
                              {t("reduxComponents.derivedItemsScheme.autoImport.label") + ":"}
                            </Col>
                            <Col>
                              {t("reduxComponents.derivedItemsScheme.autoImport.parents.label") + ":"}
                            </Col>
                            <Col>
                              <Checkbox
                                checked={importCheckbox.importParents}
                                onChange={e => onCheckboxChange({importParents: e.target.checked})}
                                disabled={isImportParentDisabled}
                              />
                            </Col>
                            <Col>
                              {t("reduxComponents.derivedItemsScheme.autoImport.children.label") + ":"}
                            </Col>
                            <Col>
                              <Checkbox
                                checked={importCheckbox.importChildren}
                                onChange={e => onCheckboxChange({importChildren: e.target.checked})}
                                disabled={isImportParentDisabled}
                              />
                            </Col>
                            <Col>
                              {t("reduxComponents.derivedItemsScheme.autoImport.descendants.label") + ":"}
                            </Col>
                            <Col>
                              <Checkbox
                                checked={importCheckbox.importDescendants}
                                onChange={e => onCheckboxChange({importDescendants: e.target.checked})}
                                disabled={isImportParentDisabled}
                              />
                            </Col>
                          </Row>
                        </Col>
                      )}
                    </Row>
                  </Col>
                )}
              </Row>
              <div className="redux-codelist-detail-modal__derived-codelist">
                {derivedCodelistViewMode === NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE
                  ? (
                    <Row type="flex" gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                      <Col span={SPAN_HALF}>
                        <Call
                          cb={fetchDCSourceItemTree}
                          cbParam={{
                            triplet: codelistTriplet,
                            lang,
                            itemsOrderAnnotationType,
                            dcTargetItemTreeTimeStamp
                          }}
                          disabled={derivedCodelistViewMode !== NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE}
                        >
                          <CheckableItemsTree
                            itemTree={dcSourceItemTree}
                            childrenKey="codes"
                            rightActions={
                              <Button
                                onClick={() => onItemsStore(dcSourceSelectedItems, false, codelistTriplet, lang, importCheckbox)}
                                icon="double-right"
                                type="primary"
                                disabled={dcSourceSelectedItems.length === 0}
                              >
                                {t('reduxComponents.derivedItemsScheme.buttons.addItems.title')}
                              </Button>
                            }
                            itemTreeMaxDepth={dcSourceItemTreeMaxDepth}
                            selectedItems={dcSourceSelectedItems}
                            onSelectedItemsChange={onSourceTreeItemSelect}
                            getIsDisabledNode={({isSelectable}) => isSelectable === false}
                          />
                        </Call>
                      </Col>
                      <Col span={SPAN_HALF}>
                        <Call
                          cb={fetchDCTargetItemTree}
                          cbParam={{
                            triplet: codelistTriplet,
                            lang,
                            itemsOrderAnnotationType,
                            dcTargetItemTreeTimestamp
                          }}
                          disabled={derivedCodelistViewMode !== NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TREE}
                        >
                          <CheckableItemsTree
                            itemTree={dcTargetItemTree}
                            childrenKey="codes"
                            rightActions={
                              <Button
                                onClick={() => onItemsStore(dcTargetSelectedItems, true, codelistTriplet, lang)}
                                icon="delete"
                                type="primary"
                                disabled={dcTargetSelectedItems.length === 0}
                              >
                                {t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')}
                              </Button>
                            }
                            itemTreeMaxDepth={dcTargetItemTreeMaxDepth}
                            selectedItems={dcTargetSelectedItems}
                            onSelectedItemsChange={onTargetTreeItemSelect}
                          />
                        </Call>
                      </Col>
                    </Row>
                  )
                  : (
                    <Row type="flex" gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                      <Col span={SPAN_HALF}>
                        <Call
                          cb={fetchSourceItemPage}
                          cbParam={dCSourceFetchPageParams}
                          disabled={currentTab !== "derived" || dCSourceFetchPageParams === null || !areParamsComplete(dCSourceFetchPageParams)}
                        >
                          <InfiniteScrollTable
                            key={currentTab}
                            data={dCSourceItemPage}
                            getRowKey={({code}) => code}
                            rowCount={dCSourceItemCount}
                            columns={columns}
                            height={TABLE_HEIGHT}
                            searchBarSpan={10}
                            rowSelection={{
                              selectedRowKeys: dCSourceItemPage
                                ? dCSourceItemPage.filter(({isSelected}) => isSelected).map(({code}) => code)
                                : [],
                              onSelect: (itemCode, selected) =>
                                onSourceItemSelect(itemCode, codelistTriplet, selected, lang),
                              onSelectAll: (selected, filter) => onAllItemsSelect(codelistTriplet, false, selected, filter, lang)
                            }}
                            getIsDisabledRow={({isSelectable}) => !isSelectable}
                            rightActions={
                              <Button
                                onClick={() => onSelectedItemsStore(false, codelistTriplet, lang, importCheckbox)}
                                icon="double-right"
                                type="primary"
                                disabled={!dCSourceSelectedItemCount || dCSourceSelectedItemCount === 0}
                              >
                                {t('reduxComponents.derivedItemsScheme.buttons.addItems.title')}
                              </Button>
                            }
                            isPaginated
                            selectedRowCount={dCSourceSelectedItemCount}
                            onChange={({
                                         pageNum,
                                         pageSize,
                                         searchText,
                                         filters,
                                         sortCol,
                                         sortByDesc
                                       }) =>
                              onSourceItemPageParamsUpdate({
                                codelistTriplet,
                                lang,
                                pageNum,
                                pageSize,
                                searchText,
                                filters,
                                sortCol,
                                sortByDesc,
                                itemsOrderAnnotationType
                              })
                            }
                          />
                        </Call>
                      </Col>
                      <Col span={SPAN_HALF}>
                        <Call
                          cb={fetchTargetItemPage}
                          cbParam={dCTargetFetchPageParams}
                          disabled={currentTab !== "derived" || dCSourceItemPage === null || dCTargetFetchPageParams === null || !areParamsComplete(dCTargetFetchPageParams)}
                        >
                          <InfiniteScrollTable
                            key={currentTab}
                            data={dCTargetItemPage}
                            getRowKey={({code}) => code}
                            rowCount={dCTargetItemCount}
                            columns={columns}
                            height={TABLE_HEIGHT}
                            searchBarSpan={10}
                            rowSelection={{
                              selectedRowKeys: dCTargetItemPage
                                ? dCTargetItemPage.filter(({isSelected}) => isSelected).map(({code}) => code)
                                : [],
                              onSelect: (itemCode, selected) =>
                                onTargetItemSelect(itemCode, codelistTriplet, selected, lang),
                              onSelectAll: (selected, filter) => onAllItemsSelect(codelistTriplet, true, selected, filter, lang)
                            }}
                            rightActions={
                              <Button
                                onClick={() => onSelectedItemsStore(true, codelistTriplet, lang)}
                                icon="delete"
                                type="primary"
                                disabled={!dCTargetSelectedItemCount || dCTargetSelectedItemCount === 0}
                              >
                                {t('reduxComponents.derivedItemsScheme.buttons.removeItems.title')}
                              </Button>
                            }
                            isPaginated
                            selectedRowCount={dCTargetSelectedItemCount}
                            onChange={({
                                         pageNum,
                                         pageSize,
                                         searchText,
                                         filters,
                                         sortCol,
                                         sortByDesc
                                       }) =>
                              onTargetItemPageParamsUpdate({
                                codelistTriplet,
                                lang,
                                pageNum,
                                pageSize,
                                searchText,
                                filters,
                                sortCol,
                                sortByDesc,
                                itemsOrderAnnotationType
                              })
                            }
                          />
                        </Call>
                      </Col>
                    </Row>
                  )}
              </div>
            </div>
            <Row type="flex" justify="end" gutter={GUTTER_SM}>
              <Col>
                <Button
                  onClick={() => onSelectedDbRestore(codelistTriplet)}
                  disabled={!(dCTargetItemCount > 0 || dcTargetItemTreeMaxDepth > 0)}
                >
                  {t('reduxComponents.derivedItemsScheme.buttons.emptyList.title')}
                </Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={() => onCreateShow(codelistTriplet, lang)}
                  disabled={!(dCTargetItemCount > 0 || dcTargetItemTreeMaxDepth > 0)}
                >
                  {t('reduxComponents.derivedItemsScheme.buttons.create.title')}
                </Button>
              </Col>
            </Row>
            <EnhancedModal
              visible={isCreateVisible && derivedCodelist !== null}
              title={t('reduxComponents.derivedItemsScheme.modals.derive.title')}
              width={MODAL_WIDTH_MD}
              withDataLanguageSelector
              onCancel={onCreateHide}
              footer={
                <div>
                  <Button onClick={onCreateHide}>{t('commons.buttons.close.title')}</Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      if (isArtefactValid(derivedCodelist)) {
                        onCreateSubmit(codelistTriplet, lang, derivedCodelist)
                      } else {
                        Modal.warning({
                          title: t('commons.alerts.invalidForm.title'),
                          content: t('commons.alerts.invalidForm.content')
                        });
                      }
                    }}
                  >
                    {t('reduxComponents.derivedItemsScheme.buttons.deriveSubmit.title')}
                  </Button>
                </div>
              }
            >
              <ArtefactMinForm
                artefact={derivedCodelist}
                agencies={agencies}
                onChange={onCreateChange}
                mode={ARTEFACT_MIN_FORM_MODE_CREATE}
              />
            </EnhancedModal>
            <Call
              cb={() => Modal.error({
                title: t('reduxComponents.derivedItemsScheme.modals.warning.parentMissing.title'),
                onOk() {
                  onCreateHide()
                },
                onCancel() {
                  onCreateHide()
                }
              })}
              disabled={!(isCreateVisible && !derivedCodelist)}
            >
              <span/>
            </Call>
          </Fragment>
        )
      }}
    </DataLanguageConsumer>
  )
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(DerivedCodelist);